@if (data.rows.length > 0) {
  <table>
    <tr>
      <td [attr.colspan]="data.rows[0].cells.length">
        <sd-4-5-1-divider></sd-4-5-1-divider>
      </td>
    </tr>

    @for (row of data.rows; track $index) {
      <tr class="tight-row">
        @for (cell of row.cells; track $index) {
          <td [innerHTML]="cell.content"></td>
        }
      </tr>

      <tr>
        <td [attr.colspan]="data.rows[0].cells.length">
          <sd-4-5-1-divider></sd-4-5-1-divider>
        </td>
      </tr>
    }
  </table>
}
